import { BRAND, CONTACT, SITE_URL } from "../data/site";
import { COUNTIES } from "../data/counties";

const ORG_ID = `${SITE_URL}/#organization`;

export const organizationSchema = () => ({
  "@context": "https://schema.org",
  "@type": ["MedicalBusiness", "ProfessionalService"],
  "@id": ORG_ID,
  name: BRAND.name,
  url: `${SITE_URL}/`,
  logo: `${SITE_URL}${BRAND.logo}`,
  image: `${SITE_URL}${BRAND.ogImage}`,
  description:
    "Virtual therapy and telehealth counseling for children, teens, adults, couples and families throughout New Jersey.",
  telephone: CONTACT.phoneE164,
  email: CONTACT.email,
  priceRange: "$$",
  availableService: { "@type": "MedicalTherapy", name: "Telehealth psychotherapy" },
  parentOrganization: { "@type": "MedicalBusiness", name: BRAND.affiliate },
  address: { "@type": "PostalAddress", addressRegion: "NJ", addressCountry: "US" },
  areaServed: [
    { "@type": "State", name: "New Jersey" },
    ...COUNTIES.map((c) => ({ "@type": "AdministrativeArea", name: `${c.name} County, NJ` })),
  ],
  openingHoursSpecification: [
    { "@type": "OpeningHoursSpecification", dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"], opens: "10:00", closes: "21:00" },
    { "@type": "OpeningHoursSpecification", dayOfWeek: ["Saturday", "Sunday"], opens: "10:00", closes: "18:00" },
  ],
  sameAs: [CONTACT.psychologyToday],
});

export const breadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
    item: `${SITE_URL}${it.path}`,
  })),
});

export const faqSchema = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.question,
    acceptedAnswer: { "@type": "Answer", text: f.answer },
  })),
});

export const serviceSchema = ({ name, description, path, areaName = "New Jersey" }) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  name,
  description,
  serviceType: "Online therapy",
  url: `${SITE_URL}${path}`,
  provider: { "@id": ORG_ID, "@type": "MedicalBusiness", name: BRAND.name },
  areaServed: { "@type": areaName === "New Jersey" ? "State" : "AdministrativeArea", name: areaName },
  availableChannel: { "@type": "ServiceChannel", name: "Telehealth (secure video)" },
});
